import React, { useEffect, useState } from 'react';

export default function withHover(WrappedComponent) {

    return class extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                hovered: false
            };
        }

        setHovered(val) {
            this.setState({ hovered: val })
        }
        render() {
            // Wraps the input component in a container, without mutating it. Good!
            return <WrappedComponent onMouseEnter={() => this.setHovered(true)} onMouseLeave={() => this.setHovered(false)} {...this.props} hovered={this.state.hovered} />;
        }
    }
}